import { render, staticRenderFns } from "./WithdrawTab.vue?vue&type=template&id=54a53c62"
import script from "./WithdrawTab.vue?vue&type=script&lang=js"
export * from "./WithdrawTab.vue?vue&type=script&lang=js"
import style0 from "./WithdrawTab.vue?vue&type=style&index=0&id=54a53c62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports